import { render, staticRenderFns } from "./ModalItemDetail.template.vue?vue&type=template&id=226de4ec&scoped=true&"
var script = {}
import style0 from "./ModalItemDetail.template.vue?vue&type=style&index=0&id=226de4ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226de4ec",
  null
  
)

export default component.exports